import { combineReducers } from 'redux'
import { alphaReducer } from 'alpha-js'

export const appReducer = combineReducers({
  alpha: alphaReducer
})
